export default __webpack_public_path__ + "static/media/risk-tab-left.62b29132.svg";